import { InstrumentItemContainer } from "./Instruments.styled";
import { HTMLAttributes } from "react";
import { getIconInstrument } from "../../../helpers";
import { INSTRUMENT_NAME } from "../../../constants";

interface InstrumentItemProps extends HTMLAttributes<HTMLDivElement> {
	isActive: boolean;
	onChangeInstrument: (value: number) => void;
	value: number;
	name: INSTRUMENT_NAME;
}

export const InstrumentItem = ({ isActive, name, children, value, onChangeInstrument }: InstrumentItemProps) => {
	const getIcon = () => {
		switch (name) {
			case INSTRUMENT_NAME.GUITAR: {
				return getIconInstrument(INSTRUMENT_NAME.GUITAR, true);
			}
			case INSTRUMENT_NAME.KEYBOARD: {
				return getIconInstrument(INSTRUMENT_NAME.KEYBOARD, true);
			}
			case INSTRUMENT_NAME.SAXOPHONE: {
				return getIconInstrument(INSTRUMENT_NAME.SAXOPHONE, true);
			}

			default:
				return null;
		}
	};

	const handleOnChangeInstrument = () => {
		onChangeInstrument(value);
	};

	return (
		<InstrumentItemContainer isActive={isActive} onClick={handleOnChangeInstrument}>
			{getIcon()}
			{children}
		</InstrumentItemContainer>
	);
};
